import { useEffect } from "react";

export default function useDynamicMeta({ title, description, image, schemaJson }) {
  useEffect(() => {
    if (!title) return;

    document.title = title;

    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) metaDescription.setAttribute("content", description || "");

    const ogTitle = document.querySelector("meta[property='og:title']");
    if (ogTitle) ogTitle.setAttribute("content", title);

    const ogDesc = document.querySelector("meta[property='og:description']");
    if (ogDesc) ogDesc.setAttribute("content", description || "");

    const ogImage = document.querySelector("meta[property='og:image']");
    if (ogImage) ogImage.setAttribute("content", image || "");

    // JSON-LD Script
    const scriptId = "structured-data";
    let scriptTag = document.getElementById(scriptId);
    if (scriptTag) scriptTag.remove();

    if (schemaJson) {
      scriptTag = document.createElement("script");
      scriptTag.type = "application/ld+json";
      scriptTag.id = scriptId;
      scriptTag.innerHTML = JSON.stringify(schemaJson);
      document.head.appendChild(scriptTag);
    }

  }, [title, description, image, schemaJson]);
}
